// extracted by mini-css-extract-plugin
export default {"content_box":"notice_content_box__E59Wa","header":"notice_header__rztZH","content":"notice_content__uqIKt","img":"notice_img__SAJwI"};